// 空间配置
export const bucket = process.env.VUE_APP_BUCKET

// 文件访问域名配置
export const picDns = bucket === 'ipark-cdn' ? 'https://yl.p.gintell.cn/' : 'https://test.qn.pic.gintell.cn/'
export const videoDns = bucket === 'ipark-cdn' ? 'https://yl.p.gintell.cn/' : 'https://test.qn.video.gintell.cn/'
export const fileDns = bucket === 'ipark-cdn' ? 'https://yl.p.gintell.cn/' : 'https://test.qn.file.gintell.cn/'
